<template>
  <div class="inner-box">
    <el-form size="mini" label-width="120px" label-position="top">
      <el-row v-if="form.squareFeeId === '' ">
        <el-col :span="8">
          <el-form-item label="적용일자" >
            <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row >
        <el-form-item label="A/S" style="color: red;">
          <el-row>
            <el-col :span="4">
              <el-form-item label="접수일처리">
                <el-input type="text" v-model="form.squareFee1" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="당일처리">
                <el-input type="text" v-model="form.squareFee2" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="D+2처리">
                <el-input type="text" v-model="form.squareFee3" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="기본처리">
                <el-input type="text" v-model="form.squareFee4" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="추가처리">
                <el-input type="text" v-model="form.squareFee5" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="추가건수">
                <el-input type="text" v-model="form.squareFee6" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="출장비">
          <el-row>
            <el-col :span="4">
              <el-form-item label="기본출장비">
                <el-input type="text" v-model="form.squareFee11" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="장거리(1급지)">
                <el-input type="text" v-model="form.squareFee12" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="장거리(2급지)">
                <el-input type="text" v-model="form.squareFee13" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="장거리(3급지)">
                <el-input type="text" v-model="form.squareFee14" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="장거리(4급지)">
                <el-input type="text" v-model="form.squareFee15" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="기본대행료">
                <el-input type="text" v-model="form.squareFee7" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="설치비">
          <el-row>
            <el-col :span="4">
              <el-form-item label="Set설치">
                <el-input type="text" v-model="form.squareFee21" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="단독설치">
                <el-input type="text" v-model="form.squareFee22" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="추가Set설치">
                <el-input type="text" v-model="form.squareFee23" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="추가단독설치">
                <el-input type="text" v-model="form.squareFee24" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="추가설치">
                <el-input type="text" v-model="form.squareFee25" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="설치추가건수">
                <el-input type="text" v-model="form.squareFee26" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "AsChargeInfo",
  props: ['groupDetail', 'parentNm'],
  data() {
    return {
      form: {
        companyId: "",
        createDt: "",
        creatorId: "",
        creatorNm: "",
        endDt: "",
        squareFee1: "",
        squareFee2: "",
        squareFee3: "",
        squareFee4: "",
        squareFee5: "",
        squareFee6: "",
        squareFee7: "",
        squareFee8: 0,
        squareFee9: 0,
        squareFee10: 0,
        squareFee11: "",
        squareFee12: "",
        squareFee13: "",
        squareFee14: "",
        squareFee15: "",
        squareFee16: 0,
        squareFee17: 0,
        squareFee18: 0,
        squareFee19: 0,
        squareFee20: 0,
        squareFee21: "",
        squareFee22: "",
        squareFee23: "",
        squareFee24: "",
        squareFee25: "",
        squareFee26: "",
        squareFee27: 0,
        squareFee28: 0,
        squareFee29: 0,
        squareFee30: 0,
        squareFeeId: "",
        squareFeeType: "",
        startDt: this.$moment().format('YYYY-MM-DD'),
        updateDt: "",
        updatorId: "",
        updatorNm: ""
      },
    };
  },
  methods: {
    setGroupInfo() {
      Object.assign(this.form, this.groupDetail, this.parentNm);
    },
  },
  watch: {
    groupDetail() {
      this.setGroupInfo();
    }
  }
}

</script>

<style lang="scss" scoped>
/* .table-area table tr th:first-child{
  border-left: 1px solid #d7d7d7;
}
.table-area table tr th, .table-area table tr td{
  border-bottom: 1px solid #d7d7d7;
} */

.el-row {
  border-bottom: 1px solid #d7d7d7;
  &:last-child {
    border-bottom: none;
  }
}

.el-form {
  border: 1px solid #d7d7d7 !important;
  padding: 10px 25px 10px 25px;
  border-radius: 5px;
}
</style>